import { Stub, TabMenu, VStack } from '@direct-frontend/components';
import { noop } from '@direct-frontend/stdlib';
import { SettingsPageLayout } from '#shared/components/SettingsPageLayout';
import { PAGE_TITLE_SETTINGS_CHARACTERISTICS } from '#shared/lib/constants';
import { CharacteristicsActiveStub } from './components/CharacteristicsActiveStub';
import { getCharacteristicsTabItems } from './model/tabs';

export const CharacteristicPageStub = () => {
    const characteristicsTabItems = getCharacteristicsTabItems();
    const defaultSelectedKey = characteristicsTabItems[0].key;

    return (
        <SettingsPageLayout
            title={PAGE_TITLE_SETTINGS_CHARACTERISTICS}
            pageHeadProps={{
                renderTabMenu: (props) => (
                    <TabMenu
                        {...props}
                        items={characteristicsTabItems}
                        selectedKey={defaultSelectedKey}
                        onChange={noop}
                    />
                ),
            }}
        >
            <VStack gap="8">
                <Stub borderRadius="14" height={44} />
                <CharacteristicsActiveStub />
            </VStack>
        </SettingsPageLayout>
    );
};
